module.exports = __webpack_public_path__ + "img/parrallel_1.605801a9.png";